import { Folder } from '@anm/api/modules/videoFolder';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { moveProjectAsync } from '../../actions';
import { findAndUpdateFolder, removeProject } from '../../helpers';
import { VideoFolderActions } from '../../types';

const moveProjectReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(moveProjectAsync.request): {
      const params = action.payload;
      return {
        ...state,
        moveProject: {
          ...state.moveProject,
          params,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(moveProjectAsync.success): {
      const { folderId, projectId } = state.moveProject.params!;

      const increaseProjectsCount = ({ projectsCount = 0, ...other }: Folder) => ({
        ...other,
        projectsCount: projectsCount + 1
      });

      const decreaseProjectsCount = ({ projectsCount = 1, ...other }: Folder) => ({
        ...other,
        projectsCount: projectsCount - 1
      });

      const increasedCountData = findAndUpdateFolder(state.folderTree.data!, folderId)(increaseProjectsCount);
      const decreasedCountData = findAndUpdateFolder(increasedCountData, state.data!.id)(decreaseProjectsCount);

      return {
        ...state,
        data: removeProject(state.data!, projectId),
        folderTree: {
          ...state.folderTree,
          data: decreasedCountData
        },
        moveProject: {
          ...state.moveProject,
          isPending: false
        }
      };
    }
    case getType(moveProjectAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        moveProject: {
          ...state.moveProject,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default moveProjectReducer;
